import React, { useRef } from 'react';
import AvatarProfile from '../AvatarProfile/AvatarProfile';
import PhotoUploadButton from '../PhotoUploadButton/PhotoUploadButton';
import AlertBanner from '../AlertBanner/AlertBanner';
import useProfilePhotoUpload from '../../../hooks/useProfilePhotoUpload';
import styles from './PortalUserProfileForm.module.css';

interface PortalUserProfilePhotoSectionProps {
  userId?: string | null;
  disabled?: boolean;
}

const PortalUserProfilePhotoSection: React.FC<PortalUserProfilePhotoSectionProps> = ({
  userId,
  disabled = false,
}) => {
  const profilePhotoInputRef = useRef<HTMLInputElement>(null);

  const {
    displayUrl: profilePhotoUrl,
    isUploading: isUploadingProfilePhoto,
    feedback: profilePhotoFeedback,
    selectFile: selectProfilePhotoFile,
    clearFeedback: clearProfilePhotoFeedback,
  } = useProfilePhotoUpload({ userId });

  const handleProfilePhotoButtonClick = () => {
    clearProfilePhotoFeedback();
    profilePhotoInputRef.current?.click();
  };

  const handleProfilePhotoInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';

    if (!file) {
      return;
    }

    await selectProfilePhotoFile(file);
  };

  return (
    <div className={styles.photoSection}>
      <p className={styles.photoLabel}>Foto de perfil</p>
      <div className={styles.avatarRow}>
        <AvatarProfile size={101} src={profilePhotoUrl} />
        <div className={styles.photoActions}>
          <PhotoUploadButton
            disabled={disabled || isUploadingProfilePhoto || !userId}
            onClick={handleProfilePhotoButtonClick}
          >
            {isUploadingProfilePhoto ? 'Enviando foto...' : 'Inserir foto'}
          </PhotoUploadButton>
          <input
            ref={profilePhotoInputRef}
            type="file"
            accept="image/png,image/jpeg,image/webp"
            onChange={handleProfilePhotoInputChange}
            className={styles.hiddenFileInput}
            disabled={disabled || !userId}
          />
        </div>
      </div>
      {profilePhotoFeedback && (
        <AlertBanner
          message={profilePhotoFeedback.message}
          variant={profilePhotoFeedback.variant}
          className={styles.photoFeedback}
        />
      )}
    </div>
  );
};

export default PortalUserProfilePhotoSection;
